import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { IntensityDegreeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  IntensityDegreeCreateDto,
  IntensityDegreeDto,
  IntensityDegreeExcelDownloadDto,
  IntensityDegreeUpdateDto,
} from '../proxy/planning/dtos/intensity-degree';
import { INTENSITYDEGREE_CONFIG, INTENSITYDEGREE_FIELDS } from './intensity-degree.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-intensity-degree',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, IntensityDegreeService, ConfirmationService],
  templateUrl: './intensity-degree.html',
  styleUrl: './intensity-degree.scss',
})
export class IntensityDegree extends BaseCrudComponent<
  IntensityDegreeDto,
  IntensityDegreeCreateDto,
  IntensityDegreeUpdateDto,
  IntensityDegreeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(IntensityDegreeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('IntensityDegree', ids),
  };
  config = INTENSITYDEGREE_CONFIG;
  fields = INTENSITYDEGREE_FIELDS;

  protected prepareUpdateDto(data: any, selected: IntensityDegreeDto): IntensityDegreeUpdateDto {
    return {
      incidentTypeId: data.incidentTypeId,
      intensityId: data.intensityId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'IntensityDegree';
  }
}
